import { clsx } from 'clsx';

type LogoMarkProps = {
  className?: string;
  alt?: string;
};

const LogoMark = ({ className, alt = 'ViralEngine' }: LogoMarkProps) => {
  return (
    <img
      src="/logo.png"
      alt={alt}
      className={clsx('h-10 w-auto object-contain', className)}
    />
  );
};

export default LogoMark;
